import React from 'react';
import { Select, Tag, Typography } from 'antd';

const MOCK_USERS = [
  { oid: 'mock-oid',   label: 'Mock Admin',    role: 'admin' },
  { oid: 'mock-oid-2', label: 'Mock QA Admin', role: 'qa_admin' },
  { oid: 'mock-oid-4', label: 'Mock QA',       role: 'qa' },
  { oid: 'mock-oid-3', label: 'Emma Wilson',   role: 'agent' },
];

const ROLE_COLOR = { admin: 'red', qa_admin: 'orange', qa: 'blue', agent: 'green' };

export default function MockUserSwitcher() {
  const current = localStorage.getItem('mockUserOid') || 'mock-oid';

  const handleChange = (oid) => {
    localStorage.setItem('mockUserOid', oid);
    window.location.reload();
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      <Tag color="volcano" style={{ margin: 0, fontSize: 11 }}>DEV</Tag>
      <Typography.Text style={{ color: '#fff', fontSize: 12, whiteSpace: 'nowrap' }}>User:</Typography.Text>
      <Select
        size="small"
        value={current}
        onChange={handleChange}
        style={{ width: 160 }}
        popupMatchSelectWidth={false}
        options={MOCK_USERS.map((u) => ({
          value: u.oid,
          label: (
            <span>
              <Tag color={ROLE_COLOR[u.role]} style={{ marginRight: 4, fontSize: 10, lineHeight: '16px', padding: '0 4px' }}>
                {u.role}
              </Tag>
              {u.label}
            </span>
          ),
        }))}
      />
    </div>
  );
}
